import { useParams } from "react-router-dom";
import CustomForm from '../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import config from '../../../application/config/config';
import Fetch from '../../../core/util/core/Fetch';
import { useSelector, useDispatch } from 'react-redux';
import { TabContent, TabPane, Nav, NavItem, NavLink, Row, Col } from 'reactstrap';
import { useEffect, useState } from 'react';
import moment from 'moment';
import classnames from 'classnames';
import sleep from 'sleep-promise';
import './Form.css';
import { chooseProfileFilter } from "../../helpers/chooseProfileFilter";

function Form() {
    const profileFilter = chooseProfileFilter();
    const incrementInput = (profileFilter.governance_room_client_city_id || Object.keys(profileFilter).length === 0
    ) ? 1 : 0;
    const { id } = useParams();
    const [form, setForm] = useState();
    const [logs, setLogs] = useState(<p>Logs...</p>);
    const [formContent, setFormContent] = useState(<>Carregando...</>);

    const dispatch = useDispatch();
    let isGeneralFile = false;
    const endpointBackend = config.endpoints.backend;
    const path = 'governanceroom/files';
    const session = useSelector((state) => { return state.session });
    const userSession = session.userSession;
    let fileTypeId = '';
    let [activeTab, setActiveTab] = useState('1');

    const changeReadOnlyToForm = (form) => {
        if (userSession.loggedUserInfo.governance_room_department_id) {
            const secretariatId = form.fields.find(item => item.name === 'governance_room_secretariat_id');
            const departmentId = form.fields.find(item => item.name === 'governance_room_department_id');
            if (secretariatId) secretariatId.readOnly = true;
            if (departmentId) departmentId.readOnly = true;
        } else if (userSession.loggedUserInfo.governance_room_secretariat_id) {
            const cityId = form.fields.find(item => item.name === 'governance_room_client_city_id');
            if (cityId) cityId.readOnly = true;
        }
        return form;
    }

    const clearValues = (values, keys = []) => {
        if (values.governance_room_city_id) {
            values.governance_room_city_id = '';
        }
        if (values.year) {
            values.year = '';
        }
        if (keys.length > 0) {
            for (const key of keys) {
                values[key] = '';
            }
        }
        return values;
    };

    const paths = {
        endpointSave: `${endpointBackend}${path}/save`,
        endpointUserGetById: `${endpointBackend}governanceroom/users/getById`,
        endpointGetById: `${endpointBackend}${path}/getById`,
        endpointGetAllLogs: `${endpointBackend}${path}/getallLogs`,
        endpointGetByIdHelp: `${endpointBackend}governanceroom/filetypes/getByIdHelp`,
        endpointGetByIdFileTypes: `${endpointBackend}governanceroom/filetypes/getById`,
        endpointGetAllPeriods: config.endpoints.backend + 'governanceroom/periods/getall',
        endpointGetAllOptionsByPeriodId: config.endpoints.backend + 'governanceroom/periods/getOptionsById',
        urlGoBack: `/${path}/list`,
        pathView: `/${path}/view`
    }

    const labels = {
        labelTitleAdd: "Novo Upload de Arquivo",
        labelTitleEdit: "Editar Upload de Arquivo",
        labelTitleView: 'Visualizar Upload de Arquivo',
    }

    const generateYears = () => {
        let years = [];
        const year = moment().year();
        for (let i = 1900; i <= year; i++) {
            years.push({
                label: i,
                value: i
            });
        }
        years.reverse();
        return years;
    }

    const generateMonths = () => {
        const monthNames = [
            'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
            'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
        ];

        return monthNames.map((name, index) => ({
            label: name,
            value: (index + 1).toString().padStart(2, '0')
        }));
    }

    const getForm = (values) => {
        const showCities = config.screen_configs.fileForm.fileTypesToShowCities.includes(values.governance_room_file_type_id);
        const showYears = config.screen_configs.fileForm.fileTypesToShowYears.includes(values.governance_room_file_type_id);
        const showMonths = config.screen_configs.fileForm.fileTypesToShowMonths.includes(values.governance_room_file_type_id) || config.screen_configs.fileForm.citiesToShowMonths.includes(values.governance_room_city_id);
        const showPeriods = config.screen_configs.fileForm.fileTypesToShowPeriods.includes(values.governance_room_file_type_id);

        let form = {
            validateOnChange: false,
            hiddenValues: {
                core_application_instance_id: userSession.user.application_instance_id,
                core_user_id: userSession.user.id,
                profileFilter
            },
            fields: [
                (!profileFilter.governance_room_client_city_id && !isGeneralFile) && {
                    name: 'governance_room_client_city_id',
                    type: 'select',
                    label: 'Município',
                    options: [],
                    optionsEndpoint: {
                        endpoint: endpointBackend + 'governanceroom/clientscities/getall',
                        label: 'company_city_name',
                        value: 'id',
                        params: {
                            filter: {
                                ...profileFilter
                            }
                        }
                    },
                    handleChange: async (element, field, values) => {
                        values = clearValues(values, [
                            'governance_room_secretariat_id',
                            'governance_room_department_id',
                            'governance_room_category_id',
                            'governance_room_file_type_id'
                        ]);
                        let form = getForm(values);
                        form = changeReadOnlyToForm(form);
                        setForm(form);
                        setFormContent(<></>);
                        await sleep(1);
                        setFormContent(
                            <CustomFormContainer
                                form={form}
                                content={<CustomForm form={form} />}
                            />)
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                !isGeneralFile && {
                    name: 'governance_room_secretariat_id',
                    type: 'select',
                    options: [],
                    optionsEndpoint: {
                        endpoint: config.endpoints.backend + 'governanceroom/secretariats/getall',
                        label: 'instance_secretariat_name',
                        value: 'id',
                        params: {
                            filter: {
                                ...profileFilter,
                                governance_room_client_city_id: profileFilter.governance_room_client_city_id ? profileFilter.governance_room_client_city_id : values.governance_room_client_city_id
                            }
                        }
                    },
                    handleChange: async (element, field, values) => {
                        values = clearValues(values, [
                            'governance_room_department_id',
                            'governance_room_category_id',
                            'governance_room_file_type_id'
                        ]);

                        let form = getForm(values);
                        form = changeReadOnlyToForm(form);
                        const currentIndex = form.fields.findIndex(field => field.name === 'governance_room_secretariat_id');
                        form.fields[currentIndex + 1].autoFocus = true;
                        setForm(form);
                        setFormContent(<></>);
                        await sleep(1);
                        setFormContent(
                            <CustomFormContainer
                                form={form}
                                content={<CustomForm form={form} />}
                            />)
                    },
                    label: 'Secretaria',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                !isGeneralFile && {
                    name: 'governance_room_department_id',
                    type: 'select',
                    options: [],
                    optionsEndpoint: {
                        endpoint: config.endpoints.backend + 'governanceroom/departments/getall',
                        label: 'instance_department_name',
                        value: 'id',
                        params: {
                            filter: {
                                governance_room_secretariat_id: values.governance_room_secretariat_id,
                                ...profileFilter,
                                governance_room_client_city_id: profileFilter.governance_room_client_city_id ? profileFilter.governance_room_client_city_id : values.governance_room_client_city_id
                            }
                        }
                    },
                    handleChange: async (element, field, values) => {
                        values = clearValues(values, [
                            'governance_room_category_id',
                            'governance_room_file_type_id'
                        ]);
                        let form = getForm(values);
                        if (values.governance_room_department_id !== '') {
                            const department = await Fetch.post(config.endpoints.backend + 'governanceroom/departments/getById', { id: values.governance_room_department_id });
                            values.governance_room_secretariat_id = department.governance_room_secretariat_id;
                        }
                        form = changeReadOnlyToForm(form);
                        const currentIndex = form.fields.findIndex(field => field.name === 'governance_room_department_id');
                        form.fields[currentIndex + 1].autoFocus = true;
                        setForm(form);
                        setFormContent(<></>);
                        await sleep(1);
                        setFormContent(
                            <CustomFormContainer
                                form={form}
                                content={<CustomForm form={form} />}
                            />)
                    },
                    label: 'Departamento',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'governance_room_category_id',
                    type: 'select',
                    label: 'Categoria do arquivo',
                    options: [],
                    optionsEndpoint: {
                        endpoint: endpointBackend + 'governanceroom/filecategories/getall',
                        label: 'file_category',
                        value: 'id',
                        params: {
                            profileFilter,
                            filter: {
                                governance_room_secretariat_id: values.governance_room_secretariat_id,
                                governance_room_department_id: values.governance_room_department_id
                            }
                        }
                    },
                    validations: {
                        required: true
                    },
                    handleChange: async (element, field, values) => {
                        values = clearValues(values, [
                            'governance_room_file_type_id'
                        ]);
                        isGeneralFile = false;
                        let form = getForm(values);
                        form = changeReadOnlyToForm(form);
                        const currentIndex = form.fields.findIndex(field => field.name === 'governance_room_category_id');
                        form.fields[currentIndex + 1].autoFocus = true;
                        setForm(form);
                        setFormContent(<></>);
                        await sleep(1);
                        setFormContent(
                            <CustomFormContainer
                                form={form}
                                content={<CustomForm form={form} />}
                            />)
                    },
                    columnSize: 12
                },
                {
                    name: 'governance_room_file_type_id',
                    type: 'select',
                    label: 'Tipo de arquivo',
                    options: [],
                    optionsEndpoint: {
                        endpoint: endpointBackend + 'governanceroom/filetypes/getall',
                        label: 'file_type',
                        value: 'id',
                        params: {
                            filter: {
                                where: {
                                    governance_room_category_id: values.governance_room_category_id,
                                    governance_room_department_id: values.governance_room_department_id,
                                    governance_room_secretariat_id: values.governance_room_secretariat_id,
                                    profileFilter
                                }
                            }
                        }
                    },
                    validations: {
                        required: true
                    },
                    handleChange: async (element, field, values) => {
                        values = clearValues(values);
                        if (!!element.target.value) {
                            let fileTypeGet = await Fetch.post(paths.endpointGetByIdFileTypes, { id: element.target.value })
                            isGeneralFile = fileTypeGet.general_file === '1';
                        }
                        fileTypeId = element.target.value;
                        let form = getForm(values);
                        let fileType = '';
                        if (!!fileTypeId) {
                            fileType = await Fetch.post(paths.endpointGetByIdHelp, { id: fileTypeId });
                            const helpIndex = form.fields.findIndex(f => f && f.name === 'archive_help');
                            const targetIndex = helpIndex !== -1 ? helpIndex : 8;
                            const hasHelp = !!fileType.archive_help;
                            const hasMeta = !!(fileType.sphere || fileType.periodicity);
                            form.fields[targetIndex].value = (hasHelp || hasMeta) ? (
                                <div id={"output"} style={{ whiteSpace: 'pre-wrap' }}>
                                    {hasMeta && (
                                        <div style={{ marginBottom: '6px', fontSize: '13px', color: '#0d6efd' }}>
                                            {fileType.sphere ? <span><strong>Esfera:</strong> {fileType.sphere}</span> : null}
                                            {fileType.sphere && fileType.periodicity ? <span> &nbsp;|&nbsp; </span> : null}
                                            {fileType.periodicity ? <span><strong>Periodicidade:</strong> {fileType.periodicity}</span> : null}
                                        </div>
                                    )}
                                    {hasHelp && (
                                        <div>
                                            <p style={{ color: 'red', margin: '0 0 4px 0', fontWeight: 'bold' }}>Atenção!!</p>
                                            {fileType.archive_help}
                                        </div>
                                    )}
                                </div>
                            ) : '';
                        }
                        form = changeReadOnlyToForm(form);
                        setForm(form);
                        setFormContent(<></>);
                        await sleep(1);
                        setFormContent(
                            <CustomFormContainer
                                form={form}
                                content={<CustomForm form={form} />}
                            />)
                    },
                    columnSize: 12
                },
                showPeriods && {
                    name: 'governance_room_period_id',
                    type: 'select',
                    label: 'Período',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllPeriods,
                        label: 'name',
                        value: 'id'
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 12,
                    handleChange: async (element, field, values) => {
                        let form = getForm(values);
                        form = changeReadOnlyToForm(form);
                        setForm(form);
                        setFormContent(<></>);
                        await sleep(1);
                        setFormContent(
                            <CustomFormContainer
                                form={form}
                                content={<CustomForm form={form} />}
                            />)
                    }
                },
                showPeriods && values.governance_room_period_id && ![config.screen_configs.fileForm.periods.yearly, config.screen_configs.fileForm.periods.monthly].includes(values.governance_room_period_id) ? {
                    name: 'period',
                    type: 'select',
                    label: 'Referência',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllOptionsByPeriodId,
                        label: 'label',
                        value: 'value',
                        params: {
                            id: values.governance_room_period_id
                        }
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 12,
                    sort: false
                } : {},
                showMonths || values.governance_room_period_id === config.screen_configs.fileForm.periods.monthly ? {
                    name: 'month',
                    type: 'select',
                    label: 'Mês',
                    options: generateMonths(),
                    validations: {
                        required: true
                    },
                    columnSize: 12
                } : {},
                showYears || showPeriods ? {
                    name: 'year',
                    type: 'select',
                    label: 'Ano',
                    options: generateYears(),
                    validations: {
                        required: true
                    },
                    columnSize: 12
                } : {},
                showCities ? {
                    name: 'governance_room_city_id',
                    type: 'select',
                    label: 'Município',
                    options: [],
                    optionsEndpoint: {
                        endpoint: endpointBackend + 'governanceroom/cities/getall',
                        label: 'city_name',
                        value: 'city_id',
                        params: {
                            filter: {
                                where: {
                                    profileFilter
                                }
                            }
                        }
                    },

                    handleChange: async (element, field, values) => {
                        let form = getForm(values);
                        form = changeReadOnlyToForm(form);
                        setForm(form);
                        setFormContent(<></>);
                        await sleep(1);
                        setFormContent(
                            <CustomFormContainer
                                form={form}
                                content={<CustomForm form={form} />}
                            />)
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 12
                } : {},
                {
                    name: 'file_path',
                    type: 'fileS3',
                    label: 'Arquivo',
                    uploadPath: 'Files',
                    extensionAccept: '.zip',
                    limitFileSize: 5048,
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    type: 'label',
                    name: 'archive_help',
                    label: '',
                    value: '',
                    columnSize: 12
                }
                // {
                //     name: 'file_path',
                //     type: 'file',
                //     label: 'Arquivo',
                //     uploadPath: '/governance_room/files/',
                //     extensionAccept: '.zip',
                //     limitFileSize: 300,
                //     columnSize: 12,
                //     validations: {
                //         required: true
                //     }
                // }
            ],
            customValidators: {
                valid_file: async (value, options, key, attributes) => {
                    if (session.current_form.file_path) {
                        dispatch({ type: 'SHOW_LOADING', value: true });
                        const post = {
                            file_path: session.current_form.file_path,
                            file_type_id: session.current_form.governance_room_file_type_id
                        };
                        const response = await Fetch.post(config.endpoints.backend + 'governanceroom/files/validatefile', post);
                        dispatch({ type: 'SHOW_LOADING', value: false });
                        if (!response.status) {
                            return `^${response.message}`;
                        } else {
                            return '';
                        }
                    } else {
                        return '';
                    }

                },
            },
            ...paths,
            ...labels,
        }
        form.values = values;
        return form;
    }

    useEffect(() => {
        const load = async () => {
            let values = {};
            if (id) {
                values = await Fetch.post(paths.endpointGetById, { id: id })
                let logsFile = await Fetch.post(paths.endpointGetAllLogs, { id });
                setLogs(logsFile);
            }
            if (userSession.loggedUserInfo.governance_room_department_id) {
                values.governance_room_secretariat_id = userSession.loggedUserInfo.governance_room_secretariat_id
                values.governance_room_department_id = userSession.loggedUserInfo.governance_room_department_id
            } else if (userSession.loggedUserInfo.governance_room_secretariat_id) {
                values.governance_room_secretariat_id = userSession.loggedUserInfo.governance_room_secretariat_id
            }

            let form = getForm(values);
            form = changeReadOnlyToForm(form);
            setForm(form);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />} />
            );
        }
        load();
    }, [])

    return (
        <div>
            <Nav tabs>
                <NavItem>
                    <NavLink
                        style={{ cursor: 'pointer' }}
                        className={classnames({ active: activeTab === '1' })}
                        onClick={() => { setActiveTab('1'); }}
                    >
                        Formulário
                    </NavLink>
                </NavItem>
                <NavItem>
                    <NavLink
                        style={{ cursor: 'pointer' }}
                        className={classnames({ active: activeTab === '2' })}
                        onClick={() => { setActiveTab('2'); }}
                    >
                        Erros
                    </NavLink>
                </NavItem>
                <NavItem>
                    <NavLink
                        style={{ cursor: 'pointer' }}
                        className={classnames({ active: activeTab === '3' })}
                        onClick={() => { setActiveTab('3'); }}
                    >
                        Logs
                    </NavLink>
                </NavItem>
            </Nav>
            <TabContent activeTab={activeTab}>
                <TabPane tabId="1">
                    <Row>
                        <Col sm="12">
                            {formContent}
                        </Col>
                    </Row>
                </TabPane>
                <TabPane tabId="2">
                    <Row>
                        <Col sm="12">
                            <p className="upload-error">{session.current_form ? session.current_form.error_message : ''}</p>
                        </Col>
                    </Row>
                </TabPane>
                <TabPane tabId="3">
                    <Row>
                        <Col sm="12">
                            <div className="upload-info">
                                {logs.length > 0 && logs.map((log, index) => (
                                    <p key={index}>{log.log}</p>
                                ))}
                            </div>
                        </Col>
                    </Row>
                </TabPane>
            </TabContent>
        </div>
    );
}
export default Form;